import * as React from "react"

const SvgSort = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M9 13.143a.97.97 0 0 1-.712-.288.97.97 0 0 1-.288-.712V5.968L6.125 7.843a.93.93 0 0 1-.687.275q-.413 0-.713-.275-.3-.3-.3-.713 0-.412.3-.712L8.3 2.843a.9.9 0 0 1 .325-.213q.176-.062.375-.062a.9.9 0 0 1 .375.062.9.9 0 0 1 .325.213l3.6 3.6q.3.3.287.7-.012.4-.312.7-.3.275-.7.287a.92.92 0 0 1-.7-.287L10 5.968v6.175a.97.97 0 0 1-.287.712.97.97 0 0 1-.713.288m6 8.575q-.2 0-.375-.063a.9.9 0 0 1-.325-.212l-3.6-3.6a.92.92 0 0 1-.287-.7q.012-.4.312-.7.3-.276.7-.288t.7.288L14 18.318v-6.175a.97.97 0 0 1 .287-.713.97.97 0 0 1 .713-.287q.424 0 .713.287.287.288.287.713v6.175l1.875-1.875a.93.93 0 0 1 .688-.275q.412 0 .712.275.3.3.3.712 0 .413-.3.713L15.7 21.443q-.15.15-.325.212a1.1 1.1 0 0 1-.375.063" />
  </svg>
)
export default SvgSort
